import React from 'react';
// antd
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
// apollo
import { resetPassword } from 'meteor-apollo-accounts';
import ApolloClient from 'ApolloClient';

// COMPONENTS
// import PublicFormTop from '/imports/ui/components/common/PublicFormTop';

// CONSTANTS & DESTRUCTURING
// ====================================
const FormItem = Form.Item;

// INTERNAL COMPONENTS
// ====================================

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitted: false,
      errors: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, { password, confirm }) => {
      if (err) {
        return;
      }
      resetPassword({ newPassword: password, token: this.props.token }, ApolloClient).then(res => {
        ApolloClient.resetStore();
        this.props.history.push('/');
        return message.success('your password was reset!', 5);
      });
      // .catch(err => alertErrors(err, this));
    });
  };

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you entered are inconsistent!');
    } else {
      callback();
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const newPasswordRules = [{ required: true, message: 'Please input a new password!' }];

    const repeatNewPassword = [
      { required: true, message: 'Please repeat the new password!' },
      { validator: this.checkPassword },
    ];

    if (this.state.submitted) {
      return (
        <div>
          <h3>Your password has been successfully reset!</h3>
        </div>
      );
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem>
          {getFieldDecorator('password', { rules: newPasswordRules })(
            <Input size="large" prefix={<Icon type="lock" />} type="password" placeholder="New password" />,
          )}
        </FormItem>
        <FormItem hasFeedback>
          {getFieldDecorator('confirm', { rules: repeatNewPassword })(
            <Input prefix={<Icon type="lock" />} type="password" size="large" placeholder="Repeat new password" />,
          )}
        </FormItem>
        <FormItem>
          <Button size="large" loading={this.state.loading} type="primary" htmlType="submit">
            Reset & Login
          </Button>
        </FormItem>
        {/* <FormErrorArea errors={this.state.errors} /> */}
      </Form>
    );
  }
}

// EXPORTED COMPONENT
// ====================================
class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      token: this.props.match.params.token,
    };
  }

  render() {
    return (
      <div className="auth-page-container">
        <div
          style={{
            width: 400,
            maxWidth: '95%',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          {/* <PublicFormTop /> */}
          <div>
            <h1 style={{ textAlign: 'center', marginBottom: 20, color: '#000' }}>Reset Your Password</h1>
            <ResetPasswordForm token={this.state.token} {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}

export default Form.create()(PasswordReset);



// WEBPACK FOOTER //
// ./src/routes/auth-password-reset/index.js